import React, { useEffect, useState } from "react";
import { Link } from "../../../../common/Link";
import { FooterWrapper, Text, PageNumberWrapper } from "../ProductsPagined.style";
import { v4 as uuidv4 } from "uuid"

export const FooterContainer = ({ pageInfo }) => {
  const [baseUrl, setBaseUrl] = useState("")
  let [currentPageNumber, setCurrentPageNumber] = useState(0)

 
  useEffect(() => {

    try {
      const regex = /\/page\d\d?\d?\/*$/s
      const currentURl = new URL(window.location.href)

      setBaseUrl(currentURl.pathname.replace(regex, ''))

      let m;

      if ((m = regex.exec(currentURl.pathname)) !== null) {
        // The result can be accessed through the `m`-variable.
        m.forEach((match, groupIndex) => {
          const current = Number(match?.match(/\d+/)[0])
          if (current)
            setCurrentPageNumber(current)
        });
      }

    } catch (error) {
      console.error("Can't build URL next page link" + error)
    }

  })

  if(pageInfo.total <= 1 ){
    return  <></>
  }

  return (
    <FooterWrapper>
      <Text>
      </Text>
      <PageNumberWrapper>
        <Links total={pageInfo.total} baseUrl={baseUrl} currentPageNumber={currentPageNumber} />
        {currentPageNumber + 1 < pageInfo.total && (
          <Link className="next" key={uuidv4()} link={`${baseUrl}${`/page${currentPageNumber + 1}`}`}>
            suivant
          </Link>
        )}
      </PageNumberWrapper>
    </FooterWrapper>
  );
};


const Links = ({ total, baseUrl, currentPageNumber }) => {
  const items = [...Array(total).keys()]
  return (<>
    {
      items.map((numPage, index) => (<Link className={currentPageNumber == index ? "currentPage" : ""} key={uuidv4()} link={`${baseUrl}${numPage > 0 ? `/page${numPage}` : ""}`}>
        {numPage + 1}
      </Link>))
    }
  </>)


}